__webpack_require__.p = "/the-artistry/";